import { createContext, useCallback, useContext, useRef, useState } from "react";
import Spinner from "./Spinner";

const ModalBusyContext = createContext(null);

const NOOP_BUSY = {
  busy: false,
  withBusy: async (fn) => fn(),
};

export function ModalBusyProvider({ children }) {
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);

  const withBusy = useCallback(async (fn) => {
    if (busyRef.current) return;
    busyRef.current = true;
    setBusy(true);
    try {
      return await fn();
    } finally {
      busyRef.current = false;
      setBusy(false);
    }
  }, []);

  return (
    <ModalBusyContext.Provider value={{ busy, withBusy }}>
      {children}
    </ModalBusyContext.Provider>
  );
}

export function useModalBusy() {
  return useContext(ModalBusyContext) || NOOP_BUSY;
}

/** Dialog-scoped veil + spinner. Mount inside `.cm-modal-dialog` / `.mkt-login-dialog`. */
export function ModalBusyOverlay() {
  const { busy } = useModalBusy();
  if (!busy) return null;
  return (
    <div className="cm-modal-busy-overlay" data-testid="modal-busy-overlay" aria-hidden="true">
      <Spinner show />
    </div>
  );
}
